import { all } from 'redux-saga/effects'
import contractSagas from './contract'
import leadersSaga from './leaders'
import eventSagas from './events'
import gameSagas from './game'
import teamSaga from './team';
import userSaga from './user'
import oracle from './oracle'
import appSagas from './app'

export default function* rootSaga() { yield all([...userSaga, ...teamSaga, ...appSagas, ...gameSagas, ...contractSagas, ...eventSagas, ...oracle, ...leadersSaga ]) } 


// WEBPACK FOOTER //
// ./src/sagas/index.js